import React from 'react';
//scss
import './About.scss';
//icon
import Smiley from '../Icons/smiley';
import Design from '../Icons/design';
import Development from '../Icons/develpment';
import Tools from '../Icons/tools';
import Frontend from '../Icons/frontend';
import Backend from '../Icons/backend';
import Frameworks from '../Icons/framework';
import Resume from '../Icons/resume';

class About extends React.Component {
  render() {
    return (
      <div className="About_wrapper">
        <div className="About">
          <Smiley name="About" />
          <div className="About_liner">
            <div className="About_liner_Text">
              <div className="About_liner_Text_title">
                ABOUT ME{' '}
                <a href="./thompsonharris.pdf" target="_blank">
                  <Resume />
                </a>
              </div>
              <div className="About_liner_Text_description">
                Artist, Educator, and Full Stack Developer always on the lookout
                to contribute to innovative and creative new projects. Focused
                on joining legible code and practical design to create projects
                that ease user interaction and spur creativity. 
                <a href="./thompsonharris.pdf" target="_blank">
                  <Resume />
                </a>
                <hr class="slash-3"></hr>
                <div className="About_liner_Text_description_projects">
                  <div className="About_liner_Text_description_projects_card">
                    <div className="About_liner_Text_description_projects_card_header">
                      <Design />
                      <div className="About_liner_Text_description_projects_card_header_title">
                        DESIGN
                      </div>
                    </div>
                    <div className="About_liner_Text_description_projects_card_text">
                      UI/UX, Figma, Photoshop, Illustrator, InDesign
                    </div>
                  </div>
                  <div className="About_liner_Text_description_projects_card">
                    <div className="About_liner_Text_description_projects_card_header">
                      <Frontend />
                      <div className="About_liner_Text_description_projects_card_header_title">
                        FRONTEND
                      </div>
                    </div>
                    <div className="About_liner_Text_description_projects_card_text">
                      React, Redux, Redux-Saga, Styled-Components, Sass, PWA,
                      Axios, Jest, Enzyme, ReactTesting Library, CSS, HTML
                    </div>
                  </div>
                  <div className="About_liner_Text_description_projects_card">
                    <div className="About_liner_Text_description_projects_card_header">
                      <Frameworks />
                      <div className="About_liner_Text_description_projects_card_header_title">
                        LANGAUGES
                      </div>
                    </div>
                    <div className="About_liner_Text_description_projects_card_text">
                      Typescript, JavaScript (ES5, ES6), Ruby, Clojure
                    </div>
                  </div>
                  <div className="About_liner_Text_description_projects_card">
                    <div className="About_liner_Text_description_projects_card_header">
                      <Backend />
                      <div className="About_liner_Text_description_projects_card_header_title">
                        BACKEND
                      </div>
                    </div>
                    <div className="About_liner_Text_description_projects_card_text">
                      Node.js, SQL, Postgres, Sequelize, MongoDB, Express,
                      GraphQL, Webpack, Redis, Firebase, AWS, Socket.io,
                    </div>
                  </div>
                  <div className="About_liner_Text_description_projects_card">
                    <div className="About_liner_Text_description_projects_card_header">
                      <Development />
                      <div className="About_liner_Text_description_projects_card_header_title">
                        DEV OPS
                      </div>
                    </div>
                    <div className="About_liner_Text_description_projects_card_text">
                      Heroku, CI/CD, Travis CI, Git, GitHub, Bitbucket
                    </div>
                  </div>
                  <div className="About_liner_Text_description_projects_card">
                    <div className="About_liner_Text_description_projects_card_header">
                      <Tools />
                      <div className="About_liner_Text_description_projects_card_header_title">
                        CMS
                      </div>
                    </div>
                    <div className="About_liner_Text_description_projects_card_text">
                      Drupal, Wordpress, Contentful, Hubspot
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
